import { AdminData, AdminDataValue } from 'shared';

export type NormalAdminDataUnit = {
  nested: false;
  key: string;
  value: AdminDataValue;
  initialValue: AdminDataValue;
  mutable: boolean;
};

export type NestedAdminDataUnit = {
  nested: true;
  key: string;
  value: AdminDataUnit[];
};

export type AdminDataUnit = NormalAdminDataUnit | NestedAdminDataUnit;

export const appToReact = (
  data: AdminData,
  mutable: boolean
): AdminDataUnit[] => {
  return Object.entries(data).map((entry) => {
    const [key, value] = entry;
    if (typeof value === 'object') {
      return {
        nested: true,
        key,
        value: appToReact(value, mutable)
      };
    }
    return {
      nested: false,
      key: entry[0],
      value: entry[1],
      initialValue: entry[1],
      mutable
    };
  });
};

export const reactToApp = (data: AdminDataUnit[]): AdminData => {
  const result: AdminData = {};
  data.forEach((dataUnit) => {
    if (dataUnit.nested) {
      result[dataUnit.key] = reactToApp(dataUnit.value);
    } else {
      result[dataUnit.key] = dataUnit.value;
    }
  });
  return result;
};
